import type { Config } from 'tailwindcss'
import sharedConfig from 'skedyul-tailwind'

const config: Pick<Config, 'prefix' | 'presets' | 'content'> = {
  content: ['./src/components/**/*.{js,ts,jsx,tsx,mdx}'],
  presets: [sharedConfig],
}

export default config
